// src/token.js
export const CESIUM_ION_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJlYjRkYzY2Ny1iM2U4LTRiMWYtODhlMS1kOTZiMTE1YmZmYTYiLCJpZCI6Mjk5MzYwLCJpYXQiOjE3NDYzNTEyMTh9.cyXf8dCAWqb0nDgoCbLywNeiqfzxTFPpSh6LMb2oz0o";